import { useState, useEffect } from 'react';

export const useIntersectionObserver = ({
	margin,
	onIntersection,
}: {
	margin: number;
	onIntersection: () => void;
}): typeof setObservedElement => {
	const [observedElement, setObservedElement] = useState<Element | null>(null);

	useEffect(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (observedElement === null || window.IntersectionObserver === undefined) {
			return undefined;
		}

		const observerCallback: IntersectionObserverCallback = (entries) =>
			entries.forEach(({ isIntersecting }) => {
				if (isIntersecting) {
					onIntersection();
				}
			});

		const observer = new IntersectionObserver(observerCallback, {
			rootMargin: `${margin}px`,
			threshold: 0,
		});

		observer.observe(observedElement);

		return () => {
			observer.disconnect();
		};
	}, [observedElement, onIntersection, margin]);

	return setObservedElement;
};
